// extracted by mini-css-extract-plugin
export var logo = "_ln-2";
export var logoWrapper = "_ln-1";
export var strip = "_ln-0";